const convertToSuperscript = (text) => {
  return text
    .replace('©', '<sup>©</sup>')
    .replace('™', '<sup>™</sup>')
    .replace('®', '<sup>®</sup>');
};

export default convertToSuperscript;
